export default function SafetySection() {
  const tips = [
    {
      icon: 'ri-shield-check-line',
      title: 'Safe Shopping Tips',
      description: 'Learn how to identify trusted sellers, verify product authenticity through QC photos, and avoid common pitfalls when using the Kakobuy Spreadsheet to find your next purchase.',
    },
    {
      icon: 'ri-search-eye-line',
      title: 'QC Inspection Guide',
      description: 'Master the art of quality control inspections. Our comprehensive guide teaches you what to look for in product photos, how to request additional details, and red flags to avoid.',
    },
    {
      icon: 'ri-truck-line',
      title: 'Shipping & Delivery Advice',
      description: 'Navigate international shipping with confidence. Get tips on choosing the best shipping methods, understanding customs processes, and tracking your Kakobuy Spreadsheet finds.',
    },
  ];

  return (
    <section className="py-20 md:py-28 px-6 md:px-12 lg:px-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        {/* Header */}
        <div className="mb-14 md:mb-16">
          <p className="text-foreground-400 text-sm font-medium tracking-wide uppercase mb-3">Why Choose Us</p>
          <h2 className="text-foreground-950 text-4xl md:text-5xl lg:text-6xl font-black font-heading leading-[1.05]">
            Safe / Smart
            <br />
            Shopping
          </h2>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {tips.map((tip, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-2xl p-8 md:p-10 flex flex-col items-start gap-5 hover:bg-background-200 transition-colors duration-300"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100">
                <i className={`${tip.icon} text-xl text-foreground-800`}></i>
              </span>
              <h3 className="text-foreground-950 text-lg font-bold font-heading">
                {tip.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {tip.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}